var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "eu-display_flex eu-column eu-mb_5" },
        [
          _c("emd-text", { staticClass: "lable_title" }, [
            _vm._v(" " + _vm._s(_vm.$t("form.title")) + " "),
          ]),
          _c(
            "emd-text",
            {
              staticClass: "eu-mt_1",
              attrs: { size: "small", tag: "p", "variation-color": "subtle" },
            },
            [_vm._v(" " + _vm._s(_vm.$t("form.subtle")) + " ")]
          ),
        ],
        1
      ),
      _c("emd-text", { staticClass: "lable_title" }, [
        _vm._v(_vm._s(_vm.$t("form.selection.scope")) + " "),
      ]),
      _c(
        "div",
        { staticClass: "container eu-mt_4 eu-mb_5" },
        _vm._l(_vm.scopes, function (scope, index) {
          return _c("div", { key: index }, [
            _c(
              "div",
              { staticClass: "scope__container" },
              [
                _c("emd-switcher", {
                  attrs: {
                    color: "primary",
                    label: _vm.$t(`form.${scope.scope}.title`),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleToggleAll(scope)
                    },
                  },
                  model: {
                    value: scope.all,
                    callback: function ($$v) {
                      _vm.$set(scope, "all", $$v)
                    },
                    expression: "scope.all",
                  },
                }),
                _c(
                  "emd-text",
                  {
                    staticClass: "eu-mt_2",
                    attrs: {
                      size: "small",
                      tag: "p",
                      "variation-color": "subtle",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t(`form.type.${scope.scope}.description`)) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "fieldset",
              {
                staticClass: "permissions__container",
                attrs: { disabled: !scope.all },
              },
              [
                _c(
                  "legend",
                  { staticClass: "eu-mb_3" },
                  [
                    _c(
                      "emd-text",
                      {
                        staticClass: "_type_caption",
                        attrs: { size: "small" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("form.selection.permission")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._l(scope.permissions, function (permission) {
                  return _c(
                    "label",
                    {
                      key: permission.type,
                      staticClass: "emd-radio-button",
                      attrs: { for: permission.name + "-" + scope.scope },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: permission.value,
                            expression: "permission.value",
                          },
                        ],
                        staticClass: "emd-radio-button__input _bold",
                        attrs: {
                          type: "radio",
                          id: permission.name + "-" + scope.scope,
                          name: "permission" + "-" + scope.scope,
                        },
                        domProps: {
                          value: true,
                          checked: _vm._q(permission.value, true),
                        },
                        on: {
                          change: [
                            function ($event) {
                              return _vm.$set(permission, "value", true)
                            },
                            function ($event) {
                              return _vm.handleTogglePermission(
                                scope,
                                permission
                              )
                            },
                          ],
                        },
                      }),
                      _c("div", { staticClass: "emd-radio-button__area" }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "emd-radio-button__text emd-text _color_default",
                        },
                        [_vm._v(_vm._s(_vm.$t(`form.type.${permission.name}`)))]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        }),
        0
      ),
      _c("hr", { staticClass: "emd-divider" }),
      _c("password-confirmation", {
        staticClass: "eu-mt_5",
        attrs: { label: "", "has-error": _vm.authError },
        model: {
          value: _vm.password,
          callback: function ($$v) {
            _vm.password = $$v
          },
          expression: "password",
        },
      }),
      _c(
        "div",
        { staticClass: "create-key__footer" },
        [
          _c(
            "emd-button",
            {
              attrs: {
                color: "primary",
                type: "outline",
                "data-testid": "close-modal",
              },
              on: { click: _vm.handleBack },
            },
            [_vm._v(" " + _vm._s(_vm.$t("general.back")) + " ")]
          ),
          _c(
            "emd-button",
            {
              attrs: {
                color: "primary",
                "data-testid": "create",
                type: "submit",
                disabled: _vm.computedDisabled,
              },
            },
            [
              _vm.isLoading
                ? _c("emd-loader")
                : _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("form.button.create")) + " "),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }